<template>
  <div id="parentregisterbylink" class="content">
    <!--        <div class="backstretch">-->
    <div class="backstretch">
      <!--            <img src="../assets/bg.jpg"/>-->
      <img v-if="isBigScreenWidth" src="../assets/bg.png" />
      <img v-if="!isBigScreenWidth" src="../assets/mobilebg.jpg" />
      <!--            <img style="background-image: url('../assets/mobilebg.jpg')" /> style="transform: rotate(20deg);" -->
    </div>

    <div class="row login-box" v-if="invalidToken && !registerSuccessfully">
      <div class="login-wrap">
        <div class="kgmLogo">
          <img src="../assets/kagami-long.png" />
        </div>

        <!--<div class="col-md-6 mb-6 login-img"></div>-->
        <!--<div class="col-md-6 mb-6 login-form col-sm-12">-->
        <!--<h1>Invalid Link</h1>-->
        <!--</div>-->
        <div class="col-md-12 mb-12 login-form col-sm-12">
          <h2 style="color: #4545ce">Invalid Link</h2>
          <!--                    <a href="/login">go to login >></a>-->
          <a href="/login" class="btn btn-primary">{{ lang('Login Now') }}</a>
        </div>
      </div>
    </div>

    <div class="row login-box" v-if="!invalidToken && email === '' && !registerSuccessfully">
      <div class="login-wrap">
        <div class="col-md-6 mb-6 login-img"></div>
        <div class="col-md-6 mb-6 login-form col-sm-12">
          <div class="kgmLogo">
            <img src="../assets/kagami-long.png" />
          </div>

          <h2 style="color: #4545ce">...Please Wait...</h2>
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row login-box" v-if="!invalidToken && email !== '' && !registerSuccessfully">
      <div class="login-wrap">
        <div class="col-md-6 mb-6 login-img"></div>
        <div class="col-md-6 mb-6 login-form col-sm-12">
          <div class="kgmLogo">
            <img src="../assets/kagami-long.png" />
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divRegister">
            <!--                        <h1>Register</h1>-->
            <span style="font-size: 10px">{{ lang('Welcome to Kagami, an in-house Student Management Solution developed for EtonHouse families.') }}</span>
            <h2 v-if="isBigScreenWidth" style="color: #4545ce">{{ lang('Getting Started') }}</h2>
            <h3 v-if="!isBigScreenWidth" style="color: #4545ce">{{ lang('Getting Started') }}</h3>
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divRegister accExistDiv">
            <a href="/login"
              ><label style="font-size: 12px">{{ lang('Already have an account') }}</label></a
            >
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divRegister">
            <!--                        <label>Email: {{email}}</label>-->
            <el-input class="regInput" :placeholder="lang('Email')" readonly="readonly" :value="email"></el-input>
          </div>

          <!--<div class="col-md-12 mb-12 col-sm-12 divRegister">-->
          <!--<label>You are: {{type}}</label>-->
          <!--</div>-->
          <!--                    <div class="col-md-12 mb-12 col-sm-12 divRegister">-->
          <!--                        <label>Password:</label>-->
          <!--                    </div>-->

          <div class="col-md-12 mb-12 col-sm-12 divRegister">
            <!-- el-input class="regInput" :placeholder="lang('Password')" v-model="password"  type="password" @input="clearErrorMsg"></el-input -->
            <el-input class="regInput" placeholder="New Passwords" v-model="password" type="password" @input="clearErrorMsg"></el-input>
          </div>
          <div class="col-md-12 mb-12 col-sm-12 divRegister">
            <!-- el-input class="regInput" :placeholder="lang('Confirm')+lang('Password')" v-model="confirmPassword" type="password" @input="clearErrorMsg"></el-input -->
            <el-input class="regInput" placeholder="Confirm New Password" v-model="confirmPassword" type="password" @input="clearErrorMsg"></el-input>
          </div>
          <div class="col-md-12 mb-12 col-sm-12 divRegister" style="margin-bottom: 10px">
            <span>Receive email reminder for new update</span>
            <el-select v-model="ntfValue" placeholder="Notification" style="display: block">
              <el-option v-for="item in ntfOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="col-md-12 mb-12 col-sm-12 divRegister divErrorMsg" v-if="errorMsg !== ''">
            <label>{{ errorMsg }}</label>
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divRegister">
            <button class="btn btn-primary" style="margin-left: unset; font-size: 12px" v-on:click="register()">{{ lang('Sign Up') }}</button>
            <div style="font-size: 10px; text-align: right; max-width: 100%">&copy; 2020 EtonHouse International Holdings Pte Ltd</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row login-box" v-if="registerSuccessfully">
      <div class="login-wrap">
        <div class="col-md-6 mb-6 login-img"></div>
        <div class="col-md-6 mb-6 login-form-success col-sm-12">
          <div class="kgmLogo">
            <img src="../assets/kagami-long.png" />
          </div>

          <div class="regSuccessBg">
            <img src="../assets/login-visual.png" />
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divSuccessfullyRegistered">
            <h4 style="color: #4545ce">{{ lang('Registration Success') }}</h4>
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divSuccessfullyRegistered">
            <span style="font-weight: normal; font-size: 12px; display: inline-block">{{ lang('Thank you for joining us') }}</span>
          </div>

          <div class="col-md-12 mb-12 col-sm-12 divSuccessfullyRegistered divGoToLogin">
            <!--                        <a href="/login">go to login >></a>-->
            <a href="/login" class="btn btn-primary">{{ lang('Login Now') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import { lang } from '../locale/index'

// import $ from 'jquery';

export default {
  name: 'ParentRegisterByLink',
  data() {
    return {
      invalidToken: false,
      email: '',
      parentID: '',
      type: '',
      password: '',
      confirmPassword: '',
      errorMsg: '',
      registerSuccessfully: false,
      isBigScreenWidth: true,

      ntfValue: 'Daily',
      ntfOption: [
        {
          value: 'Daily',
          label: lang('Daily'),
        },
        {
          value: 'Weekly',
          label: lang('Weekly'),
        },
        {
          value: 'Monthly',
          label: lang('Monthly'),
        },
        {
          value: 'Off',
          label: lang('Off'),
        },
      ],
    }
  },
  async created() {
    await this.GetParentRegisterDetails(decodeURI(this.$route.query.id))
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  methods: {
    lang,
    async GetParentRegisterDetails(token) {
      try {
        const response = await DataSource.shared.GetParentRegisterDetails(token)
        if (response) {
          switch (response.code) {
            case '99':
              this.invalidToken = true
              break
          }

          this.email = response.email
          this.parentID = response.parentID
          this.type = response.type
        }
      } catch (e) {
        this.results = e
      }
    },
    async register() {
      if (this.password !== this.confirmPassword) {
        this.errorMsg = 'Password and Confirm Password have to be same'
      } else if (!this.checkPasswordStrength1() || !this.checkPasswordStrength2()) {
        this.errorMsg = 'Your password must include uppercase, lowercase, number, and have at least 8 characters.'
      } else if (this.password.length < 8) {
        this.errorMsg = 'Password length must more than 7'
      } else if (this.ntfValue === '') {
        this.errorMsg = 'Please select notification'
      } else {
        const response = await DataSource.shared.parentRegistrationByLink(this.email, this.password, this.type, this.parentID, this.ntfValue)
        if (response) {
          switch (response.code) {
            case '99':
              this.errorMsg = 'Error: Please try again later...'
              break
            case '3':
              this.errorMsg = 'This account have been registered...'
              break
            case '2':
              this.errorMsg = 'You have another login account...'
              break
          }

          this.registerSuccessfully = true
        }
      }
    },
    clearErrorMsg() {
      this.errorMsg = ''
    },

    isMobile() {
      // if (screen.width <= 760) {
      if (window.innerWidth <= 760) {
        this.isBigScreenWidth = false
        // return true;
      } else {
        this.isBigScreenWidth = true
        // return false;
      }
    },

    checkPasswordStrength1() {
      var isValid = false
      if (/[A-Z]/.test(this.password) && /[a-z]/.test(this.password) && /[0-9]/.test(this.password) && this.password.length >= 8) {
        isValid = true
      }
      return isValid
    },

    checkPasswordStrength2() {
      var isValid = false
      if (/[A-Z]/.test(this.confirmPassword) && /[a-z]/.test(this.confirmPassword) && /[0-9]/.test(this.confirmPassword) && this.confirmPassword.length >= 8) {
        isValid = true
      }
      return isValid
    },
  },
  mounted() {
    this.isMobile()
  },
}
</script>

<style scoped>
.backstretch img {
  width: 100%;
}
.divSuccessfullyRegistered,
.divRegister {
  /*margin-bottom: 20px;*/
}
.divGoToLogin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.divErrorMsg {
  color: red;
  font-size: 12px;
}

.kgmLogo {
  text-align: right;
  margin-bottom: 30px;
}

.kgmLogo img {
  height: 30px;
}

.login-wrap {
  background-color: white;
}

.login-form {
  text-align: left;
  background-color: white;
}

.login-form-success {
  background-color: white;
}

.divGoToLogin a {
  font-size: 12px;
  margin: auto;
  font-weight: bold;
}

.login .backstretch img,
.parent-register .backstretch img {
  height: 100%;
  min-width: 100%;
  width: auto !important;
  /*object-fit: cover;*/
}

/*.backstretch {*/
/*    background-image: url("../assets/mobilebg.jpg");*/
/*    background-size: cover;*/
/*    background-position: left;*/
/*}*/

.accExistDiv a label {
  cursor: pointer;
}

@media (max-width: 769px) {
  .login .backstretch,
  .parent-register .backstretch,
  .resetPassword .backstretch,
  .resetEmail .backstretch {
    display: block !important;
  }

  .login .backstretch img,
  .parent-register .backstretch img {
    height: 100%;
    min-width: 100%;
    width: auto !important;
    object-fit: cover;
  }

  .login-wrap,
  .login-form {
    background: transparent;
  }
}

@media (max-width: 450px) {
  .login .backstretch,
  .parent-register .backstretch,
  .resetPassword .backstretch,
  .resetEmail .backstretch {
    display: block !important;
  }

  .login .backstretch img,
  .parent-register .backstretch img {
    height: 100%;
    min-width: 100%;
    width: auto !important;
    object-fit: cover;
  }

  .login-wrap,
  .login-form {
    background: transparent;
  }
}
</style>

<style>
.regInput .el-input__inner {
  background-color: #f7f7f7;
  border-color: #f7f7f7;
  margin-bottom: 10px;
  font-size: 12px;
}

.parent-register {
  overflow: hidden;
}
</style>
